export function setToken(content: string) {
    if (!localStorage) {
        throw new Error('您的浏览器不支持localStorage，请尝试更新浏览器');
    }
    localStorage.setItem('token', content);
}
export function getToken() {
    if (!localStorage) {
        return '';
    }
    const token = localStorage.getItem('token') || '';
    if (token === 'undefined') {
        return '';
    }
    return token;
}

export function removeToken() {
    localStorage.removeItem('token');
}

export function getUserInfoFromStorage(): {
    id: number;
    avatarUrl: string;
    username: string;
    userType: string; // admin,user
} | null {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

    if (Object.keys(userInfo).length <= 0) return null;

    return userInfo;
}
